export default __webpack_public_path__ + "static/media/02.5568fb44.jpg";